import { Storybook } from "@tento-ui/ui/storybook";
import { Round } from "@tento-ui/components/round";
import { SchedulingLinkSidebar } from "./scheduling-link-sidebar";
import { SchedulingLinks } from "@tento-lona";
import { RowNetworkKey, UserId } from "@tento-lona/sheets";
import { MemorySchedulingLinkStore, mockLinkAttributes } from "./create-scheduling-link-form.example";

function makeMockLinks(): SchedulingLinks.Row[] {
  const now = new Date().toISOString();
  return [
    new SchedulingLinks.Row({
      id: RowNetworkKey.fromWire("1234"),
      ownerId: UserId.of("user_abc123"),
      label: "Meet with Abby",
      lookupKey: ":bookings:meet-with-abby",
      attributes: mockLinkAttributes({
        slug: "meet-with-abby",
        durationMinutes: 30,
        timezone: "America/New_York",
        availability: [],
        isActive: true,
        createdAt: now,
        updatedAt: now,
      }),
    }),
    new SchedulingLinks.Row({
      id: RowNetworkKey.fromWire("5678"),
      ownerId: UserId.of("user_abc123"),
      label: "Design Review",
      lookupKey: ":bookings:design-review",
      attributes: mockLinkAttributes({
        slug: "design-review",
        durationMinutes: 60,
        timezone: "America/Los_Angeles",
        availability: [],
        isActive: true,
        createdAt: now,
        updatedAt: now,
      }),
    }),
  ];
}

export class SchedulingLinkSidebarStoryBook extends Storybook.Default {
  title(): string {
    return "Scheduling Link Sidebar";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "With links",
        render: () => {
          const store = new MemorySchedulingLinkStore(makeMockLinks());
          const $sidebar = SchedulingLinkSidebar.make().bind(store, () => {});
          return Round.makeWithContent(
            $sidebar.assignStyles({ height: "400px" }),
            Round.Props.FLAT_CARD,
          );
        },
      },
      {
        title: "Empty state",
        render: () => {
          const store = new MemorySchedulingLinkStore([]);
          const $sidebar = SchedulingLinkSidebar.make().bind(store, () => {});
          return Round.makeWithContent(
            $sidebar.assignStyles({ height: "400px" }),
            Round.Props.FLAT_CARD,
          );
        },
      },
    ];
  }
}
